import { PortfolioSummaryConfigAction } from 'widgets/portfolioSummary/store/instances/configuration/actions';
import { Action } from 'store/store';
import { WidgetActionPayload } from 'widgets/store/actions';
import { PortfolioSummaryDataAction } from 'widgets/portfolioSummary/store/data/actions';
import { PortfolioSummaryComponentAction } from 'widgets/portfolioSummary/store/instances/component/actions';

export enum PortfolioSummaryActionType {
    PORTFOLIO_SUMMARY_INITIALISE = 'PORTFOLIO_SUMMARY_INITIALISE',
}

export type PortfolioSummaryInitialiseAction = Action<
    PortfolioSummaryActionType.PORTFOLIO_SUMMARY_INITIALISE,
    WidgetActionPayload
>;

export const portfolioSummaryInitialise: (
    widgetKey: string
) => PortfolioSummaryInitialiseAction = (widgetKey) => ({
    type: PortfolioSummaryActionType.PORTFOLIO_SUMMARY_INITIALISE,
    payload: { widgetKey },
});

export type PortfolioSummaryWidgetActionWithoutInitialise =
    | PortfolioSummaryConfigAction
    | PortfolioSummaryComponentAction;

export type PortfolioSummaryWidgetAction =
    | PortfolioSummaryInitialiseAction
    | PortfolioSummaryWidgetActionWithoutInitialise;

export type PortfolioSummaryAction =
    | PortfolioSummaryWidgetAction
    | PortfolioSummaryDataAction;
